import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormGridComponent from 'modules/ui/editform/subForm/EditFormGridComponent';
import { useParams, withRouter } from 'react-router';
import FieldType from 'app/admin/dataset/dto/FieldType';
import SimulationMonitorLogEditService from '../service/SimulationMonitorLogEditService';

const config = data => {
	return {
		key: 'simulationMonitorLogEditForm',
		topic: 'simulationMonitorLog',
		service: SimulationMonitorLogEditService,
		tabList: initData => {
			return [{ key: 'basic' }, { key: 'fields' }];
		},
		fields: initData => {
			const fields = [
				{
					key: 'name',
					component: EditFormTextField,
					required: true,
					readOnly: data.id !== 'new'
				},
				{
					key: 'tableName',
					component: EditFormTextField,
					required: true
				},
				{
					key: 'description',
					component: EditFormTextField,
					multiline: true
				},
				{
					key: 'fields',
					tab: 'fields',
					component: EditFormGridComponent,
					defaultValue: {
						name: null,
						type: null
					},
					fields: [
						{
							key: 'name',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'type',
							component: EditFormSelectField,
							required: true,
							type: 'enum',
							items: Object.keys(FieldType).map(key => {
								return { label: FieldType[key], value: key };
							})
						}
					]
				}
			];

			return fields;
		}
	};
};

function SimulationMonitorLogEditForm() {
	const { id } = useParams();
	const myConfig = config({ id });

	return (
		<EditFormPage config={myConfig} />
	);
}

export default withRouter(SimulationMonitorLogEditForm);